export default __webpack_public_path__ + "static/media/dr-lim-su-lin.547f62b1.png";